<template>
  <v-container>

    <template v-if="floors.length">

      <v-card
        elevation="3"
        outlined
        :loading="loading"
        v-for="floor of floors"
        :key="floor.id"
        class="mb-4"
      >
        <v-card-title>
          {{floor.name[language]}}
        </v-card-title>

        <v-card-text>
          {{ $t('floors.floorNumber') }}: {{ floor.floorNumber }}
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            :to="`/floors/${floor.id}`"
          >
            {{ $t('common.show') }}
          </v-btn>

          <v-btn
            color="primary"
            :to="`/floors/${floor.id}/update`"
          >
            {{ $t('common.update') }}
          </v-btn>

          <v-spacer />

          <v-btn
            color="error"
            @click="deleteFloor(floor)"
          >
            {{ $t('common.delete') }}
          </v-btn>

        </v-card-actions>
      </v-card>

      <v-btn plain color="primary" to="/floors/new">
        {{ $t('floors.list.newFloor') }}
      </v-btn>

    </template>

    <template v-else>
      <v-row justify="center" align="center" class="max-height">
        {{ $t('floors.list.noFloor') }}
        <v-btn plain color="primary" to="/floors/new">
          {{ $t('floors.list.newFloor') }}
        </v-btn>
      </v-row>
    </template>

  </v-container>
</template>

<script>
import i18n from '@/i18n';

export default {
  name: 'FloorList',
  components: {},
  data: () => ({
    dialog: false,
  }),
  created() {
    this.$store.dispatch('floor/listFloors');
  },
  computed: {
    floors() {
      return this.$store.state.floor.floors;
    },
    loading() {
      return this.$store.state.floor.loading;
    },
    language() {
      return this.$i18n.locale;
    },
  },
  methods: {
    async deleteFloor(floor) {
      if (await this.$root.$confirm.open(
        i18n.t('common.delete'),
        i18n.t('floors.deleteConfirm'),
        { color: 'red', itemName: floor.name[this.language] },
      )) {
        await this.$store.dispatch('floor/deleteFloor', floor);
        this.$store.dispatch('floor/listFloors');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  .max-height {
    height: 100%;
  }
}
</style>
